export const Pokedex: import('../../../sim/dex-species').ModdedSpeciesDataTable = {
	aegislash: {
		inherit: true,
		types: ["Ghost", "Fighting"],
		baseStats: { hp: 60, atk: 50, def: 140, spa: 50, spd: 140, spe: 60 },
		otherFormes: ["Aegislash-Blade", "Aegislash-Soulbound"],
		formeOrder: ["Aegislash", "Aegislash-Blade", "Aegislash-Soulbound"],
	},
	aegislashblade: {
		inherit: true,
		types: ["Ghost", "Fighting"],
		baseStats: { hp: 60, atk: 140, def: 50, spa: 140, spd: 50, spe: 60 },
	},
	aegislashsoulbound: {
		num: 681,
		name: "Aegislash-Soulbound",
		baseSpecies: "Aegislash",
		forme: "Soulbound",
		types: ["Ghost", "Fighting"],
		baseStats: { hp: 60, atk: 140, def: 140, spa: 50, spd: 50, spe: 60 },
		abilities: { 0: "Stance Change" },
		heightm: 1.7,
		weightkg: 53,
		color: "Brown",
		eggGroups: ["Mineral"],
		requiredMove: "Soulbound Slash",
		battleOnly: "Aegislash",
	},
	alcremie: {
		inherit: true,
		baseStats: { hp: 90, atk: 60, def: 75, spa: 110, spd: 121, spe: 64 },
		abilities: { 0: "Aroma Veil" },
		otherFormes: [
			"Alcremie-Sweetened", "Alcremie-Sweetened-Ruby-Cream", "Alcremie-Sweetened-Matcha-Cream",
			"Alcremie-Sweetened-Mint-Cream", "Alcremie-Sweetened-Lemon-Cream", "Alcremie-Sweetened-Salted-Cream",
			"Alcremie-Sweetened-Ruby-Swirl", "Alcremie-Sweetened-Caramel-Swirl", "Alcremie-Sweetened-Rainbow-Swirl",
		],
		formeOrder: [
			"Alcremie", "Alcremie-Ruby-Cream", "Alcremie-Matcha-Cream", "Alcremie-Mint-Cream", "Alcremie-Lemon-Cream", "Alcremie-Salted-Cream",
			"Alcremie-Ruby-Swirl", "Alcremie-Caramel-Swirl", "Alcremie-Rainbow-Swirl", "Alcremie-Sweetened", "Alcremie-Sweetened-Ruby-Cream",
			"Alcremie-Sweetened-Matcha-Cream", "Alcremie-Sweetened-Mint-Cream", "Alcremie-Sweetened-Lemon-Cream", "Alcremie-Sweetened-Salted-Cream",
			"Alcremie-Sweetened-Ruby-Swirl", "Alcremie-Sweetened-Caramel-Swirl", "Alcremie-Sweetened-Rainbow-Swirl",
		],
	},
	alcremiesweetened: {
		num: 869,
		name: "Alcremie-Sweetened",
		baseSpecies: "Alcremie",
		forme: "Sweetened",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Supersweet Syrup" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "White",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie",
	},
	alcremiesweetenedrubycream: {
		num: 869,
		name: "Alcremie-Sweetened-Ruby-Cream",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Ruby-Cream",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Competitive" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Pink",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Ruby-Cream",
	},
	alcremiesweetenedmatchacream: {
		num: 869,
		name: "Alcremie-Sweetened-Matcha-Cream",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Matcha-Cream",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Heatproof" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Green",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Matcha-Cream",
	},
	alcremiesweetenedmintcream: {
		num: 869,
		name: "Alcremie-Sweetened-Mint-Cream",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Mint-Cream",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Snow Warning" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Blue",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Mint-Cream",
	},
	alcremiesweetenedlemoncream: {
		num: 869,
		name: "Alcremie-Sweetened-Lemon-Cream",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Lemon-Cream",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Screen Cleaner" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Yellow",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Lemon-Cream",
	},
	alcremiesweetenedsaltedcream: {
		num: 869,
		name: "Alcremie-Sweetened-Salted-Cream",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Salted-Cream",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Purifying Salt" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Yellow",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Salted-Cream",
	},
	alcremiesweetenedrubyswirl: {
		num: 869,
		name: "Alcremie-Sweetened-Ruby-Swirl",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Ruby-Swirl",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Trace" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Yellow",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Ruby-Swirl",
	},
	alcremiesweetenedcaramelswirl: {
		num: 869,
		name: "Alcremie-Sweetened-Caramel-Swirl",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Caramel-Swirl",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Sand Spit" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Yellow",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Caramel-Swirl",
	},
	alcremiesweetenedrainbowswirl: {
		num: 869,
		name: "Alcremie-Sweetened-Rainbow-Swirl",
		baseSpecies: "Alcremie",
		forme: "Sweetened-Rainbow-Swirl",
		types: ["Fairy"],
		baseStats: { hp: 90, atk: 80, def: 95, spa: 130, spd: 141, spe: 84 },
		abilities: { 0: "Pastel Veil" },
		heightm: 0.3,
		weightkg: 0.5,
		color: "Yellow",
		eggGroups: ["Fairy", "Amorphous"],
		battleOnly: "Alcremie-Rainbow-Swirl",
	},
	aurorus: {
		inherit: true,
		types: ["Ice", "Rock"],
		baseStats: { hp: 123, atk: 77, def: 92, spa: 99, spd: 102, spe: 58 },
		abilities: { 0: "Snow Warning" },
		otherFormes: ["Aurorus-Glorious"],
		formeOrder: ["Aurorus", "Aurorus-Glorious"],
	},
	aurorusglorious: {
		num: 699,
		name: "Aurorus-Glorious",
		baseSpecies: "Aurorus",
		forme: "Glorious",
		types: ["Ice", "Fairy"],
		baseStats: { hp: 143, atk: 77, def: 112, spa: 109, spd: 101, spe: 58 },
		abilities: { 0: "Mega Launcher" },
		heightm: 2.7,
		weightkg: 225,
		color: "Blue",
		eggGroups: ["Monster"],
		battleOnly: "Aurorus",
	},
	beartic: {
		inherit: true,
		baseStats: { hp: 95, atk: 130, def: 80, spa: 70, spd: 80, spe: 50 },
		abilities: { 0: "Slush Rush" },
		otherFormes: ["Beartic-Freshwater"],
		formeOrder: ["Beartic", "Beartic-Freshwater"],
	},
	bearticfreshwater: {
		num: 614,
		name: "Beartic-Freshwater",
		baseSpecies: "Beartic",
		forme: "Freshwater",
		types: ["Ice", "Water"],
		baseStats: { hp: 95, atk: 130, def: 90, spa: 85, spd: 90, spe: 105 },
		abilities: { 0: "Drizzle" },
		heightm: 2.6,
		weightkg: 260,
		color: "White",
		eggGroups: ["Field"],
		battleOnly: "Beartic",
	},
	blaziken: {
		inherit: true,
		baseStats: { hp: 80, atk: 120, def: 70, spa: 110, spd: 70, spe: 80 },
		abilities: { 0: "Tough Claws" },
		otherFormes: ["Blaziken-Mega", "Blaziken-Wildfire"],
		formeOrder: ["Blaziken", "Blaziken-Mega", "Blaziken-Wildfire"],
	},
	blazikenwildfire: {
		num: 257,
		name: "Blaziken-Wildfire",
		baseSpecies: "Blaziken",
		forme: "Wildfire",
		types: ["Fire", "Fighting"],
		baseStats: { hp: 80, atk: 120, def: 70, spa: 110, spd: 70, spe: 80 },
		abilities: { 0: "Burnout" },
		heightm: 1.9,
		weightkg: 52,
		color: "Red",
		eggGroups: ["Field"],
		battleOnly: "Blaziken",
	},
	clawitzer: {
		inherit: true,
		types: ["Water", "Dragon"],
		baseStats: { hp: 71, atk: 73, def: 88, spa: 120, spd: 89, spe: 94 },
		abilities: { 0: "Mega Launcher" },
		otherFormes: ["Clawitzer-Curled"],
		formeOrder: ["Clawitzer", "Clawitzer-Curled"],
	},
	clawitzercurled: {
		num: 693,
		name: "Clawitzer-Curled",
		baseSpecies: "Clawitzer",
		forme: "Curled",
		types: ["Water", "Steel"],
		baseStats: { hp: 71, atk: 73, def: 128, spa: 89, spd: 120, spe: 54 },
		abilities: { 0: "Prism Armor" },
		heightm: 1.3,
		weightkg: 35.3,
		color: "Blue",
		eggGroups: ["Water 1", "Water 3"],
		battleOnly: "Clawitzer",
	},
	cofagrigus: {
		inherit: true,
		types: ["Ghost", "Steel"],
		baseStats: { hp: 58, atk: 95, def: 145, spa: 50, spd: 105, spe: 30 },
		abilities: { 0: "Mummy" },
		otherFormes: ["Cofagrigus-Unchained"],
		formeOrder: ["Cofagrigus", "Cofagrigus-Unchained"],
	},
	cofagrigusunchained: {
		num: 563,
		name: "Cofagrigus-Unchained",
		baseSpecies: "Cofagrigus",
		forme: "Unchained",
		types: ["Ghost", "Dragon"],
		baseStats: { hp: 120, atk: 105, def: 95, spa: 145, spd: 55, spe: 100 },
		abilities: { 0: "Dark Magic" },
		heightm: 1.7,
		weightkg: 76.5,
		color: "Yellow",
		eggGroups: ["Mineral", "Amorphous"],
		requiredMove: "Curse",
		battleOnly: "Cofagrigus",
	},
	crustle: {
		inherit: true,
		types: ["Bug", "Rock"],
		baseStats: { hp: 70, atk: 105, def: 125, spa: 65, spd: 75, spe: 45 },
		abilities: { 0: "Weak Armor" },
		otherFormes: ["Crustle-Crawler"],
		formeOrder: ["Crustle", "Crustle-Crawler"],
	},
	crustlecrawler: {
		num: 558,
		name: "Crustle-Crawler",
		baseSpecies: "Crustle",
		forme: "Crawler",
		types: ["Bug", "Dark"],
		baseStats: { hp: 70, atk: 115, def: 85, spa: 75, spd: 55, spe: 85 },
		abilities: { 0: "Sharpness" },
		heightm: 0.4,
		weightkg: 29,
		color: "Red",
		eggGroups: ["Bug", "Mineral"],
		requiredMove: "Shell Smash",
		battleOnly: "Crustle",
	},
	darmanitan: {
		inherit: true,
		types: ["Fire"],
		baseStats: { hp: 105, atk: 140, def: 55, spa: 30, spd: 55, spe: 95 },
		abilities: { 0: "Sheer Force" },
		otherFormes: ["Darmanitan-Zen", "Darmanitan-Galar", "Darmanitan-Galar-Zen", "Darmanitan-Mega"],
		formeOrder: ["Darmanitan", "Darmanitan-Zen", "Darmanitan-Galar", "Darmanitan-Galar-Zen", "Darmanitan-Mega"],
	},
	darmanitanmega: {
		num: 555,
		name: "Darmanitan-Mega",
		baseSpecies: "Darmanitan",
		forme: "Mega",
		types: ["Fire", "Fighting"],
		baseStats: { hp: 105, atk: 160, def: 80, spa: 35, spd: 80, spe: 120 },
		abilities: { 0: "Moxie" },
		heightm: 1.3,
		weightkg: 92.9,
		color: "Red",
		eggGroups: ["Field"],
		requiredItem: "Darminitanite",
	},
	diancie: {
		inherit: true,
		types: ["Rock", "Fairy"],
		baseStats: { hp: 50, atk: 100, def: 150, spa: 100, spd: 150, spe: 50 },
		abilities: { 0: "Clear Body" },
		otherFormes: ["Diancie-Mega", "Diancie-Infused"],
		formeOrder: ["Diancie", "Diancie-Mega", "Diancie-Infused"],
	},
	diancieinfused: {
		num: 719,
		name: "Diancie-Infused",
		baseSpecies: "Diancie",
		forme: "Infused",
		types: ["Rock", "Fairy"],
		baseStats: { hp: 50, atk: 100, def: 200, spa: 100, spd: 200, spe: 50 },
		abilities: { 0: "Gem Infusion" },
		heightm: 0.7,
		weightkg: 8.8,
		color: "Pink",
		eggGroups: ["Undiscovered"],
		tags: ["Mythical"],
		battleOnly: "Diancie",
	},
	dragapult: {
		inherit: true,
		types: ["Dragon", "Ghost"],
		baseStats: { hp: 88, atk: 120, def: 75, spa: 100, spd: 75, spe: 142 },
		abilities: { 0: "Infiltrator" },
		otherFormes: ["Dragapult-Manifest"],
		formeOrder: ["Dragapult", "Dragapult-Manifest"],
	},
	dragapultmanifest: {
		num: 887,
		name: "Dragapult-Manifest",
		baseSpecies: "Dragapult",
		forme: "Manifest",
		types: ["Dragon", "Ghost"],
		baseStats: { hp: 88, atk: 130, def: 75, spa: 130, spd: 75, spe: 102 },
		abilities: { 0: "Analytic" },
		heightm: 3,
		weightkg: 50,
		color: "Green",
		eggGroups: ["Amorphous", "Dragon"],
		battleOnly: "Dragapult",
	},
	drifblim: {
		inherit: true,
		types: ["Ghost", "Flying"],
		baseStats: { hp: 150, atk: 80, def: 44, spa: 90, spd: 54, spe: 80 },
		abilities: { 0: "Aftermath" },
		otherFormes: ["Drifblim-Inflamed"],
		formeOrder: ["Drifblim", "Drifblim-Inflamed"],
	},
	drifbliminflamed: {
		num: 426,
		name: "Drifblim-Inflamed",
		baseSpecies: "Drifblim",
		forme: "Inflamed",
		types: ["Ghost", "Flying"],
		baseStats: { hp: 150, atk: 100, def: 44, spa: 100, spd: 44, spe: 100 },
		abilities: { 0: "Berserk" },
		heightm: 1.2,
		weightkg: 15,
		color: "Purple",
		eggGroups: ["Amorphous"],
		requiredAbility: "Berserk",
		battleOnly: "Drifblim",
	},
	dudunsparce: {
		inherit: true,
		types: ["Normal"],
		baseStats: { hp: 125, atk: 110, def: 80, spa: 85, spd: 75, spe: 55 },
		abilities: { 0: "Serene Grace" },
		otherFormes: ["Dudunsparce-Three-Segment", "Du-Dudunsparce", "Dudunsparce-tongueemoji"],
		formeOrder: ["Dudunsparce", "Dudunsparce-Three-Segment", "Du-Dudunsparce", "Dudunsparce-tongueemoji"],
	},
	dududunsparce: {
		num: 982,
		name: "Du-Dudunsparce",
		baseSpecies: "Dudunsparce",
		forme: "Du",
		types: ["Normal"],
		baseStats: { hp: 70, atk: 120, def: 80, spa: 85, spd: 75, spe: 130 },
		abilities: { 0: "Natural Cure" },
		heightm: 4.5,
		weightkg: 47.4,
		color: "Yellow",
		eggGroups: ["Field"],
		battleOnly: "Dudunsparce",
	},
	dudunsparcetongueemoji: {
		num: 982,
		name: "Dudunsparce-tongueemoji",
		baseSpecies: "Dudunsparce",
		forme: "tongueemoji",
		types: ["Normal"],
		baseStats: { hp: 100, atk: 130, def: 90, spa: 100, spd: 85, spe: 145 },
		abilities: { 0: "Natural Cure" },
		heightm: 4.5,
		weightkg: 47.4,
		color: "Yellow",
		eggGroups: ["Field"],
		battleOnly: "Dudunsparce",
	},
	electrode: {
		inherit: true,
		types: ["Electric"],
		baseStats: { hp: 60, atk: 50, def: 70, spa: 80, spd: 80, spe: 150 },
		abilities: { 0: "Soundproof", 1: "Static", H: "Aftermath" },
		otherFormes: ["Electrode-Hisui"],
		formeOrder: ["Electrode", "Electrode-Hisui"],
	},
	// "Different Pokemon" that escapes from Electrode
	shakite: {
		num: 10001,
		name: "Shakite",
		types: ["Steel", "Flying"],
		baseStats: { hp: 60, atk: 120, def: 150, spa: 50, spd: 100, spe: 20 },
		abilities: { 0: "Aerilate" },
		heightm: 1,
		weightkg: 666.6,
		color: "Red",
		eggGroups: ["Mineral"],
	},
	emolga: {
		inherit: true,
		num: 1038,
		name: "Emolga",
		types: ["Electric", "Flying"],
		baseStats: { hp: 55, atk: 75, def: 60, spa: 75, spd: 60, spe: 103 },
		abilities: { 0: "Speed Boost" },
		otherFormes: ["Emolga-Mega"],
		formeOrder: ["Emolga", "Emolga-Mega"],
	},
	emolgamega: {
		num: 587,
		name: "Emolga-Mega",
		baseSpecies: "Emolga",
		forme: "Mega",
		types: ["Electric", "Flying"],
		baseStats: { hp: 55, atk: 95, def: 75, spa: 125, spd: 75, spe: 103 },
		abilities: { 0: "Aeolian Drift" },
		heightm: 0.4,
		weightkg: 5,
		color: "White",
		eggGroups: ["Field"],
		requiredItem: "Emolgite",
	},
	fearow: {
		inherit: true,
		types: ["Normal", "Flying"],
		baseStats: { hp: 65, atk: 90, def: 65, spa: 61, spd: 61, spe: 100 },
		abilities: { 0: "Sniper" },
		otherFormes: ["Fearow-Ferocious"],
		formeOrder: ["Fearow", "Fearow-Ferocious"],
	},
	fearowferocious: {
		num: 22,
		name: "Fearow-Ferocious",
		baseSpecies: "Fearow",
		forme: "Ferocious",
		types: ["Fighting", "Flying"],
		baseStats: { hp: 45, atk: 60, def: 15, spa: 31, spd: 11, spe: 80 },
		abilities: { 0: "Wonder Guard" },
		heightm: 1.2,
		weightkg: 38,
		color: "Brown",
		eggGroups: ["Flying"],
		battleOnly: "Fearow",
	},
	flygon: {
		inherit: true,
		types: ["Ground", "Dragon"],
		baseStats: { hp: 80, atk: 80, def: 80, spa: 100, spd: 80, spe: 100 },
		abilities: { 0: "Levitate" },
		otherFormes: ["Flygon-Mega"],
		formeOrder: ["Flygon", "Flygon-Mega"],
	},
	flygonmega: {
		num: 330,
		name: "Flygon-Mega",
		baseSpecies: "Flygon",
		forme: "Mega",
		types: ["Ground", "Fairy"],
		baseStats: { hp: 80, atk: 105, def: 95, spa: 125, spd: 95, spe: 120 },
		abilities: { 0: "Contrary" },
		heightm: 2,
		weightkg: 82,
		color: "Green",
		eggGroups: ["Bug", "Dragon"],
		requiredItem: "Flygonite",
	},
	genesect: {
		inherit: true,
		baseStats: { hp: 71, atk: 120, def: 95, spa: 120, spd: 95, spe: 99 },
		abilities: { 0: "Mega Launcher" },
		otherFormes: [
			"Genesect-Douse", "Genesect-Shock", "Genesect-Burn", "Genesect-Chill",
			"Genesect-Core", "Genesect-Rust", "Genesect-Airborne", "Genesect-Luminous",
		],
		formeOrder: [
			"Genesect", "Genesect-Douse", "Genesect-Shock", "Genesect-Burn", "Genesect-Chill",
			"Genesect-Core", "Genesect-Rust", "Genesect-Airborne", "Genesect-Luminous",
		],
	},
	genesectcore: {
		num: 649,
		name: "Genesect-Core",
		baseSpecies: "Genesect",
		forme: "Core",
		types: ["Bug", "Fighting"],
		baseStats: { hp: 71, atk: 120, def: 95, spa: 120, spd: 95, spe: 99 },
		abilities: { 0: "Martialize" },
		heightm: 1.5,
		weightkg: 82.5,
		color: "Purple",
		eggGroups: ["Undiscovered"],
		tags: ["Mythical"],
		requiredItem: "Burn Drive",
		battleOnly: "Genesect-Burn",
	},
	genesectrust: {
		num: 649,
		name: "Genesect-Rust",
		baseSpecies: "Genesect",
		forme: "Rust",
		types: ["Bug", "Poison"],
		baseStats: { hp: 71, atk: 120, def: 95, spa: 120, spd: 95, spe: 99 },
		abilities: { 0: "Intoxicate" },
		heightm: 1.5,
		weightkg: 82.5,
		color: "Purple",
		eggGroups: ["Undiscovered"],
		tags: ["Mythical"],
		requiredItem: "Douse Drive",
		battleOnly: "Genesect-Douse",
	},
	genesectairborne: {
		num: 649,
		name: "Genesect-Airborne",
		baseSpecies: "Genesect",
		forme: "Airborne",
		types: ["Bug", "Flying"],
		baseStats: { hp: 71, atk: 120, def: 95, spa: 120, spd: 95, spe: 99 },
		abilities: { 0: "Aerilate" },
		heightm: 1.5,
		weightkg: 82.5,
		color: "Purple",
		eggGroups: ["Undiscovered"],
		tags: ["Mythical"],
		requiredItem: "Shock Drive",
		battleOnly: "Genesect-Shock",
	},
	genesectluminous: {
		num: 649,
		name: "Genesect-Luminous",
		baseSpecies: "Genesect",
		forme: "Luminous",
		types: ["Bug", "Fairy"],
		baseStats: { hp: 71, atk: 120, def: 95, spa: 120, spd: 95, spe: 99 },
		abilities: { 0: "Pixilate" },
		heightm: 1.5,
		weightkg: 82.5,
		color: "Purple",
		eggGroups: ["Undiscovered"],
		tags: ["Mythical"],
		requiredItem: "Chill Drive",
		battleOnly: "Genesect-Chill",
	},
	gliscor: {
		inherit: true,
		types: ["Ground", "Flying"],
		baseStats: { hp: 75, atk: 95, def: 125, spa: 45, spd: 75, spe: 95 },
		abilities: { 0: "Poison Heal" },
		otherFormes: ["Gliscor-Sated"],
		formeOrder: ["Gliscor", "Gliscor-Sated"],
	},
	gliscorsated: {
		num: 472,
		name: "Gliscor-Sated",
		baseSpecies: "Gliscor",
		forme: "Sated",
		types: ["Dark", "Ground"],
		baseStats: { hp: 75, atk: 125, def: 109, spa: 95, spd: 85, spe: 101 },
		abilities: { 0: "Toxic Boost" },
		heightm: 2,
		weightkg: 42.5,
		color: "Purple",
		eggGroups: ["Bug"],
		battleOnly: "Gliscor",
	},
	ironvaliant: {
		inherit: true,
		types: ["Fairy", "Fighting"],
		baseStats: { hp: 94, atk: 96, def: 94, spa: 96, spd: 94, spe: 116 },
		abilities: { 0: "Quark Drive" },
		otherFormes: ["Iron Valiant-High-Judge"],
		formeOrder: ["Iron Valiant", "Iron Valiant-High-Judge"],
	},
	ironvalianthighjudge: {
		num: 1006,
		name: "Iron Valiant-High-Judge",
		baseSpecies: "Iron Valiant",
		forme: "High-Judge",
		types: ["Fairy", "Fighting"],
		baseStats: { hp: 94, atk: 102, def: 106, spa: 102, spd: 106, spe: 108 },
		abilities: { 0: "Evil Eye" },
		heightm: 1.4,
		weightkg: 35,
		color: "White",
		tags: ["Paradox"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Iron Valiant",
	},
	jirachi: {
		inherit: true,
		types: ["Fairy", "Steel"],
		baseStats: { hp: 100, atk: 100, def: 100, spa: 100, spd: 100, spe: 100 },
		abilities: { 0: "Serene Grace" },
		otherFormes: ["Jirachi-Harmonic"],
		formeOrder: ["Jirachi", "Jirachi-Harmonic"],
	},
	jirachiharmonic: {
		num: 385,
		name: "Jirachi-Harmonic",
		baseSpecies: "Jirachi",
		forme: "Harmonic",
		types: ["Fairy", "Psychic"],
		baseStats: { hp: 100, atk: 105, def: 75, spa: 115, spd: 85, spe: 120 },
		abilities: { 0: "Prism Armor" },
		heightm: 0.3,
		weightkg: 1.1,
		color: "Yellow",
		tags: ["Mythical"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Jirachi",
	},
	kecleon: {
		inherit: true,
		baseStats: { hp: 60, atk: 90, def: 70, spa: 60, spd: 120, spe: 85 },
		abilities: { 0: "Color Change" },
		otherFormes: ["Kecleon-Volcanic", "Kecleon-Wild", "Kecleon-Luminous", "Kecleon-Storybook", "Kecleon-Phasic", "Kecleon-Ruffian"],
		formeOrder: ["Kecleon", "Kecleon-Volcanic", "Kecleon-Wild", "Kecleon-Luminous", "Kecleon-Storybook", "Kecleon-Phasic", "Kecleon-Ruffian"],
	},
	kecleonvolcanic: {
		num: 352,
		name: "Kecleon-Volcanic",
		baseSpecies: "Kecleon",
		forme: "Volcanic",
		types: ["Fire", "Rock", "Ground"],
		baseStats: { hp: 60, atk: 90, def: 120, spa: 60, spd: 85, spe: 70 },
		abilities: { 0: "Volcanic Palette" },
		heightm: 1,
		weightkg: 22,
		color: "Green",
		eggGroups: ["Field"],
		battleOnly: "Kecleon",
	},
	kecleonwild: {
		num: 352,
		name: "Kecleon-Wild",
		baseSpecies: "Kecleon",
		forme: "Wild",
		types: ["Grass", "Bug", "Poison"],
		baseStats: { hp: 60, atk: 120, def: 90, spa: 60, spd: 70, spe: 85 },
		abilities: { 0: "Wild Palette" },
		heightm: 1,
		weightkg: 22,
		color: "Green",
		eggGroups: ["Field"],
		battleOnly: "Kecleon",
	},
	kecleonluminous: {
		num: 352,
		name: "Kecleon-Luminous",
		baseSpecies: "Kecleon",
		forme: "Luminous",
		types: ["Electric", "Fairy", "Psychic"],
		baseStats: { hp: 60, atk: 85, def: 70, spa: 60, spd: 90, spe: 120 },
		abilities: { 0: "Luminious Palette" },
		heightm: 1,
		weightkg: 22,
		color: "Green",
		eggGroups: ["Field"],
		battleOnly: "Kecleon",
	},
	kecleonstorybook: {
		num: 352,
		name: "Kecleon-Storybook",
		baseSpecies: "Kecleon",
		forme: "Storybook",
		types: ["Ghost", "Dragon", "Steel"],
		baseStats: { hp: 60, atk: 85, def: 120, spa: 60, spd: 90, spe: 70 },
		abilities: { 0: "Storybook Palette" },
		heightm: 1,
		weightkg: 22,
		color: "Green",
		eggGroups: ["Field"],
		battleOnly: "Kecleon",
	},
	kecleonphasic: {
		num: 352,
		name: "Kecleon-Phasic",
		baseSpecies: "Kecleon",
		forme: "Phasic",
		types: ["Ice", "Water", "Flying"],
		baseStats: { hp: 60, atk: 90, def: 70, spa: 60, spd: 85, spe: 120 },
		abilities: { 0: "Phasic Palette" },
		heightm: 1,
		weightkg: 22,
		color: "Green",
		eggGroups: ["Field"],
		battleOnly: "Kecleon",
	},
	kecleonruffian: {
		num: 352,
		name: "Kecleon-Ruffian",
		baseSpecies: "Kecleon",
		forme: "Ruffian",
		types: ["Normal", "Fighting", "Dark"],
		baseStats: { hp: 60, atk: 120, def: 85, spa: 60, spd: 70, spe: 90 },
		abilities: { 0: "Ruffian Palette" },
		heightm: 1,
		weightkg: 22,
		color: "Green",
		eggGroups: ["Field"],
		battleOnly: "Kecleon",
	},
	kommoo: {
		inherit: true,
		types: ["Dragon", "Fighting"],
		baseStats: { hp: 75, atk: 110, def: 125, spa: 100, spd: 105, spe: 85 },
		abilities: { 0: "Soundproof" },
		otherFormes: ["Kommo-o-Totem", "Kommo-o-Hard-Rock"],
		formeOrder: ["Kommo-o", "Kommo-o-Totem", "Kommo-o-Hard-Rock"],
	},
	kommoohardrock: {
		num: 784,
		name: "Kommo-o-Hard-Rock",
		baseSpecies: "Kommo-o",
		forme: "Hard-Rock",
		types: ["Dragon", "Fighting", "Rock"],
		baseStats: { hp: 75, atk: 110, def: 125, spa: 100, spd: 105, spe: 85 },
		abilities: { 0: "Backbeat" },
		heightm: 1.6,
		weightkg: 78.2,
		color: "Gray",
		eggGroups: ["Dragon"],
		battleOnly: "Kommo-o",
	},
	landorustherian: {
		inherit: true,
	},
	landorustherianancestral: {
		num: 645,
		name: "Landorus-Therian-Ancestral",
		baseSpecies: "Landorus",
		forme: "Therian-Ancestral",
		types: ["Ground", "Flying"],
		baseStats: { hp: 89, atk: 110, def: 90, spa: 106, spd: 80, spe: 125 },
		abilities: { 0: "Download" },
		heightm: 1.3,
		weightkg: 68,
		color: "Brown",
		eggGroups: ["Undiscovered"],
		requiredMove: "Generational De-Evolution",
		battleOnly: "Landorus-Therian",
	},
	landorus: {
		inherit: true,
		types: ["Ground", "Flying"],
		baseStats: { hp: 89, atk: 125, def: 90, spa: 115, spd: 80, spe: 101 },
		abilities: { 0: "Sheer Force" },
		otherFormes: ["Landorus-Therian", "Landorus-Ancestral", "Landorus-Therian-Ancestral"],
		formeOrder: ["Landorus", "Landorus-Therian", "Landorus-Ancestral", "Landorus-Therian-Ancestral"],
	},
	landorusancestral: {
		num: 645,
		name: "Landorus-Ancestral",
		baseSpecies: "Landorus",
		forme: "Ancestral",
		types: ["Ground", "Flying"],
		baseStats: { hp: 89, atk: 106, def: 90, spa: 110, spd: 80, spe: 125 },
		abilities: { 0: "Download" },
		heightm: 1.5,
		weightkg: 68,
		color: "Brown",
		tags: ["Sub-Legendary"],
		eggGroups: ["Undiscovered"],
		requiredMove: "Generational De-Evolution",
		battleOnly: "Landorus",
	},
	petilil: {
		inherit: true,
		evos: ["Lilligant"],
	},
	lilligant: {
		inherit: true,
		types: ["Grass", "Fighting"],
		baseStats: { hp: 70, atk: 105, def: 75, spa: 50, spd: 75, spe: 105 },
		abilities: { 0: "Dancer" },
	},
	lilliganthisui: {
		num: 549,
		name: "Lilligant-Hisui",
		baseSpecies: "Lilligant",
		forme: "Hisui",
		types: ["Grass", "Fairy"],
		baseStats: { hp: 70, atk: 60, def: 60, spa: 110, spd: 60, spe: 120 },
		abilities: { 0: "Drought" },
		heightm: 1.2,
		weightkg: 19.2,
		color: "Green",
		eggGroups: ["Grass"],
		battleOnly: "Lilligant",
	},
	lucario: {
		inherit: true,
		types: ["Fighting", "Steel"],
		baseStats: { hp: 70, atk: 110, def: 70, spa: 115, spd: 70, spe: 90 },
		abilities: { 0: "Inner Focus" },
		otherFormes: ["Lucario-Mega", "Lucario-Aura Bond"],
		formeOrder: ["Lucario", "Lucario-Mega", "Lucario-Aura Bond"],
	},
	lucarioaurabond: {
		num: 448,
		name: "Lucario-Aura Bond",
		baseSpecies: "Lucario",
		forme: "Aura Bond",
		types: ["Fighting", "Steel"],
		baseStats: { hp: 70, atk: 120, def: 70, spa: 120, spd: 105, spe: 110 },
		abilities: { 0: "Aura Partner" },
		heightm: 1.2,
		weightkg: 54,
		color: "Blue",
		eggGroups: ["Field", "Human-Like"],
		requiredAbility: "Aura Partner",
		battleOnly: "Lucario",
	},
	luvdisc: {
		inherit: true,
		types: ["Water"],
		baseStats: { hp: 43, atk: 30, def: 55, spa: 40, spd: 65, spe: 97 },
		abilities: { 0: "Trying My Best" },
		otherFormes: ["Luvdisc-Heartbreak"],
		formeOrder: ["Luvdisc", "Luvdisc-Heartbreak"],
	},
	luvdischeartbreak: {
		num: 370,
		name: "Luvdisc-Heartbreak",
		baseSpecies: "Luvdisc",
		forme: "Heartbreak",
		types: ["Water", "Fairy"],
		baseStats: { hp: 43, atk: 120, def: 85, spa: 60, spd: 95, spe: 127 },
		abilities: { 0: "Pixilate" },
		heightm: 0.6,
		weightkg: 8.7,
		color: "Pink",
		eggGroups: ["Water 2"],
		requiredAbility: "Trying My Best",
		battleOnly: "Luvdisc",
	},
	luxray: {
		inherit: true,
		types: ["Electric", "Steel"],
		baseStats: { hp: 80, atk: 120, def: 79, spa: 95, spd: 79, spe: 70 },
		abilities: { 0: "Overcharged" },
		otherFormes: ["Luxray-Conductive"],
		formeOrder: ["Luxray", "Luxray-Conductive"],
	},
	luxrayconductive: {
		num: 405,
		name: "Luxray-Conductive",
		baseSpecies: "Luxray",
		forme: "Conductive",
		types: ["Electric", "Steel"],
		baseStats: { hp: 80, atk: 140, def: 40, spa: 73, spd: 40, spe: 150 },
		abilities: { 0: "Overcharged" },
		heightm: 1.4,
		weightkg: 42,
		color: "Blue",
		eggGroups: ["Field"],
		battleOnly: "Luxray",
	},
	magcargo: {
		inherit: true,
		types: ["Fire", "Rock"],
		baseStats: { hp: 60, atk: 50, def: 120, spa: 90, spd: 80, spe: 30 },
		abilities: { 0: "Flame Body" },
		otherFormes: ["Magcargo-Fractured"],
		formeOrder: ["Magcargo", "Magcargo-Fractured"],
	},
	magcargofractured: {
		num: 219,
		name: "Magcargo-Fractured",
		baseSpecies: "Magcargo",
		forme: "Fractured",
		types: ["Fire", "Rock"],
		baseStats: { hp: 60, atk: 75, def: 105, spa: 110, spd: 145, spe: 35 },
		abilities: { 0: "Regenerator" },
		heightm: 0.8,
		weightkg: 55,
		color: "Red",
		eggGroups: ["Amorphous"],
		battleOnly: "Magcargo",
	},
	mamoswine: {
		inherit: true,
		types: ["Ice", "Ground"],
		baseStats: { hp: 110, atk: 130, def: 80, spa: 70, spd: 60, spe: 80 },
		abilities: { 0: "Thick Fat" },
		otherFormes: ["Mamoswine-Overflow"],
		formeOrder: ["Mamoswine", "Mamoswine-Overflow"],
	},
	mamoswineoverflow: {
		num: 473,
		name: "Mamoswine-Overflow",
		baseSpecies: "Mamoswine",
		forme: "Overflow",
		types: ["Ice", "Ghost"],
		baseStats: { hp: 110, atk: 145, def: 60, spa: 85, spd: 80, spe: 150 },
		abilities: { 0: "Regenerator" },
		heightm: 2.7,
		weightkg: 111,
		color: "Brown",
		eggGroups: ["Field"],
		requiredItem: "Mysterious Tusk",
		battleOnly: "Mamoswine",
	},
	mesprit: {
		inherit: true,
		types: ["Psychic"],
		baseStats: { hp: 80, atk: 105, def: 105, spa: 105, spd: 105, spe: 80 },
		abilities: { 0: "Levitate" },
		otherFormes: ["Mesprit-Rampaging"],
		formeOrder: ["Mesprit", "Mesprit-Rampaging"],
	},
	mespritrampaging: {
		num: 481,
		name: "Mesprit-Rampaging",
		baseSpecies: "Mesprit",
		forme: "Rampaging",
		types: ["Psychic", "Dark"],
		baseStats: { hp: 80, atk: 100, def: 140, spa: 115, spd: 140, spe: 100 },
		abilities: { 0: "Rampage" },
		heightm: 0.3,
		weightkg: 0.3,
		color: "Pink",
		tags: ["Sub-Legendary"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Mesprit",
	},
	mewtwo: {
		inherit: true,
		types: ["Psychic", "Dark"],
		baseStats: { hp: 106, atk: 110, def: 90, spa: 154, spd: 90, spe: 130 },
		abilities: { 0: "Unnerve" },
		otherFormes: ["Mewtwo-Mega-X", "Mewtwo-Mega-Y", "Mewtwo-Evil-Scary"],
		formeOrder: ["Mewtwo", "Mewtwo-Mega-X", "Mewtwo-Mega-Y", "Mewtwo-Evil-Scary"],
	},
	mewtwoevilscary: {
		num: 150,
		name: "Mewtwo-Evil-Scary",
		baseSpecies: "Mewtwo",
		forme: "Evil-Scary",
		types: ["Dark"],
		baseStats: { hp: 106, atk: 150, def: 70, spa: 194, spd: 120, spe: 140 },
		abilities: { 0: "Insomnia" },
		heightm: 2,
		weightkg: 122,
		color: "Purple",
		eggGroups: ["Undiscovered"],
		tags: ["Restricted Legendary"],
		battleOnly: "Mewtwo",
	},
	octillery: {
		inherit: true,
		types: ["Water"],
		baseStats: { hp: 100, atk: 105, def: 100, spa: 105, spd: 100, spe: 45 },
		abilities: { 0: "Guided Missiles" },
		otherFormes: ["Octillery-Sharpshooter"],
		formeOrder: ["Octillery", "Octillery-Sharpshooter"],
	},
	octillerysharpshooter: {
		num: 224,
		name: "Octillery-Sharpshooter",
		baseSpecies: "Octillery",
		forme: "Sharpshooter",
		types: ["Water", "Steel"],
		baseStats: { hp: 100, atk: 105, def: 110, spa: 130, spd: 110, spe: 45 },
		abilities: { 0: "Focused Fire" },
		heightm: 0.9,
		weightkg: 28.5,
		color: "Red",
		eggGroups: ["Water 1", "Water 2"],
		battleOnly: "Octillery",
	},
	ogerpon: {
		inherit: true,
		otherFormes: [
			"Ogerpon-Wellspring", "Ogerpon-Hearthflame", "Ogerpon-Cornerstone", "Ogerpon-Teal-Tera", "Ogerpon-Wellspring-Tera",
			"Ogerpon-Hearthflame-Tera", "Ogerpon-Cornerstone-Tera", "Ogerpon-Pixiedust", "Ogerpon-Pixiedust-Tera",
		],
		formeOrder: [
			"Ogerpon", "Ogerpon-Wellspring", "Ogerpon-Hearthflame", "Ogerpon-Cornerstone", "Ogerpon-Teal-Tera", "Ogerpon-Wellspring-Tera",
			"Ogerpon-Hearthflame-Tera", "Ogerpon-Cornerstone-Tera", "Ogerpon-Pixiedust", "Ogerpon-Pixiedust-Tera",
		],
	},
	ogerponpixiedust: {
		num: 1017,
		name: "Ogerpon-Pixiedust",
		baseSpecies: "Ogerpon",
		forme: "Pixiedust",
		types: ["Grass", "Fairy"],
		baseStats: { hp: 80, atk: 120, def: 84, spa: 60, spd: 96, spe: 110 },
		abilities: { 0: "Shield Dust" },
		heightm: 1.2,
		weightkg: 39.8,
		color: "Green",
		tags: ["Sub-Legendary"],
		eggGroups: ["Undiscovered"],
		requiredItem: "Pixiedust Mask",
		changesFrom: "Ogerpon",
		requiredTeraType: "Fairy",
	},
	ogerponpixiedusttera: {
		num: 1017,
		name: "Ogerpon-Pixiedust-Tera",
		baseSpecies: "Ogerpon",
		forme: "Pixiedust-Tera",
		types: ["Grass", "Fairy"],
		gender: "F",
		baseStats: { hp: 80, atk: 120, def: 84, spa: 60, spd: 96, spe: 110 },
		abilities: { 0: "Embody Aspect (Pixiedust)" },
		heightm: 1.2,
		weightkg: 39.8,
		color: "Pink",
		eggGroups: ["Undiscovered"],
		requiredItem: "Pixiedust Mask",
		battleOnly: "Ogerpon-Pixiedust",
		requiredTeraType: "Fairy",
	},
	parasect: {
		inherit: true,
		types: ["Bug", "Grass"],
		baseStats: { hp: 60, atk: 95, def: 80, spa: 60, spd: 80, spe: 30 },
		abilities: { 0: "Effect Spore" },
		otherFormes: ["Parasect-Wicked"],
		formeOrder: ["Parasect", "Parasect-Wicked"],
	},
	parasectwicked: {
		num: 47,
		name: "Parasect-Wicked",
		baseSpecies: "Parasect",
		forme: "Wicked",
		types: ["Bug", "Dark"],
		baseStats: { hp: 80, atk: 110, def: 70, spa: 115, spd: 65, spe: 111 },
		abilities: { 0: "Shroom n Doom" },
		heightm: 1,
		weightkg: 29.5,
		color: "Red",
		eggGroups: ["Bug", "Grass"],
		requiredItem: "Dreamy Mushroom",
		battleOnly: "Parasect",
	},
	pecharunt: {
		inherit: true,
		types: ["Poison", "Ghost"],
		baseStats: { hp: 88, atk: 88, def: 88, spa: 88, spd: 88, spe: 160 },
		abilities: { 0: "Poison Puppeteer" },
		otherFormes: ["Pecharunt-Puppetmaster"],
		formeOrder: ["Pecharunt", "Pecharunt-Puppetmaster"],
	},
	pecharuntpuppetmaster: {
		num: 1025,
		name: "Pecharunt-Puppetmaster",
		baseSpecies: "Pecharunt",
		forme: "Puppetmaster",
		types: ["Poison", "Ghost"],
		baseStats: { hp: 88, atk: 160, def: 88, spa: 88, spd: 88, spe: 88 },
		abilities: { 0: "Intimidate" },
		heightm: 0.3,
		weightkg: 0.3,
		color: "Purple",
		tags: ["Mythical"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Pecharunt",
	},
	rayquaza: {
		inherit: true,
		types: ["Dragon", "Flying"],
		baseStats: { hp: 105, atk: 150, def: 90, spa: 150, spd: 90, spe: 95 },
		abilities: { 0: "Primal Shackle" },
		otherFormes: ["Rayquaza-Mega", "Rayquaza-Untethered"],
		formeOrder: ["Rayquaza", "Rayquaza-Mega", "Rayquaza-Untethered"],
	},
	rayquazauntethered: {
		num: 384,
		name: "Rayquaza-Untethered",
		baseSpecies: "Rayquaza",
		forme: "Untethered",
		types: ["Dragon", "Stellar"],
		baseStats: { hp: 100, atk: 165, def: 95, spa: 165, spd: 95, spe: 150 },
		abilities: { 0: "Beast Boost" },
		heightm: 7,
		weightkg: 206.5,
		color: "Green",
		tags: ["Restricted Legendary"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Rayquaza",
	},
	regigigas: {
		inherit: true,
		types: ["Normal"],
		baseStats: { hp: 110, atk: 160, def: 110, spa: 80, spd: 110, spe: 100 },
		abilities: { 0: "Slow Start" },
		otherFormes: ["Regigigas-Colossal"],
		formeOrder: ["Regigigas", "Regigigas-Colossal"],
	},
	regigigascolossal: {
		num: 486,
		name: "Regigigas-Colossal",
		baseSpecies: "Regigigas",
		forme: "Colossal",
		types: ["Normal", "Fighting"],
		baseStats: { hp: 130, atk: 130, def: 130, spa: 130, spd: 130, spe: 70 },
		abilities: { 0: "Martialize" },
		heightm: 3.7,
		weightkg: 999.9,
		color: "White",
		tags: ["Sub-Legendary"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Regigigas",
	},
	rhyperior: {
		inherit: true,
		types: ["Rock", "Ground"],
		baseStats: { hp: 125, atk: 140, def: 130, spa: 55, spd: 55, spe: 40 },
		abilities: { 0: "Solid Rock" },
		otherFormes: ["Rhyperior-Adversity"],
		formeOrder: ["Rhyperior", "Rhyperior-Adversity"],
	},
	rhyperioradversity: {
		num: 464,
		name: "Rhyperior-Adversity",
		baseSpecies: "Rhyperior",
		forme: "Adversity",
		types: ["Rock", "Ground"],
		baseStats: { hp: 125, atk: 140, def: 130, spa: 55, spd: 75, spe: 80 },
		abilities: { 0: "Emergency Cannon" },
		heightm: 2.4,
		weightkg: 282.8,
		color: "Gray",
		eggGroups: ["Monster", "Field"],
		battleOnly: "Rhyperior",
	},
	samurott: {
		inherit: true,
		types: ["Water"],
		baseStats: { hp: 95, atk: 100, def: 85, spa: 108, spd: 70, spe: 70 },
		abilities: { 0: "Supreme Overlord" },
		otherFormes: ["Samurott-Hisui", "Samurott-Overlord"],
		formeOrder: ["Samurott", "Samurott-Hisui", "Samurott-Overlord"],
	},
	samurottoverlord: {
		num: 503,
		name: "Samurott-Overlord",
		baseSpecies: "Samurott",
		forme: "Overlord",
		types: ["Water", "Fighting"],
		baseStats: { hp: 95, atk: 115, def: 70, spa: 115, spd: 70, spe: 85 },
		abilities: { 0: "Supreme Overlord" },
		heightm: 1.5,
		weightkg: 58.2,
		color: "Blue",
		eggGroups: ["Field"],
		battleOnly: "Samurott",
	},
	shayminsky: {
		inherit: true,
		types: ["Grass", "Flying"],
		baseStats: { hp: 100, atk: 100, def: 100, spa: 100, spd: 100, spe: 100 },
		abilities: { 0: "Serene Grace" },
	},
	shaymin: {
		inherit: true,
		types: ["Grass"],
		baseStats: { hp: 100, atk: 100, def: 100, spa: 100, spd: 100, spe: 100 },
		abilities: { 0: "Flower Veil" },
	},
	shedinja: {
		inherit: true,
		types: ["Bug", "Ghost"],
		baseStats: { hp: 80, atk: 90, def: 90, spa: 30, spd: 90, spe: 40 },
		maxHP: undefined,
		abilities: { 0: "Wonder Guard" },
		otherFormes: ["Shedinja-Escaped"],
		formeOrder: ["Shedinja", "Shedinja-Escaped"],
	},
	shedinjaescaped: {
		num: 292,
		name: "Shedinja-Escaped",
		baseSpecies: "Shedinja",
		forme: "Escaped",
		types: ["Ghost", "Flying"],
		baseStats: { hp: 80, atk: 90, def: 30, spa: 90, spd: 30, spe: 160 },
		abilities: { 0: "Wonder Guard" },
		heightm: 0.8,
		weightkg: 1.2,
		color: "Brown",
		eggGroups: ["Mineral"],
		requiredAbility: "Wonder Guard",
		battleOnly: "Shedinja",
	},
	simisear: {
		inherit: true,
		types: ["Fire"],
		baseStats: { hp: 75, atk: 98, def: 63, spa: 98, spd: 63, spe: 101 },
		abilities: { 0: "Blaze" },
		otherFormes: ["Simisear-Ultra"],
		formeOrder: ["Simisear", "Simisear-Ultra"],
	},
	simisearultra: {
		num: 514,
		name: "Simisear-Ultra",
		baseSpecies: "Simisear",
		forme: "Ultra",
		types: ["Fire", "Electric"],
		baseStats: { hp: 75, atk: 132, def: 73, spa: 132, spd: 73, spe: 117 },
		abilities: { 0: "Galvanize" },
		heightm: 1.8,
		weightkg: 75,
		color: "Red",
		eggGroups: ["Field"],
		requiredItem: "Ultrasimisearium Z",
		battleOnly: "Simisear",
	},
	slowking: {
		inherit: true,
		types: ["Water", "Psychic"],
		baseStats: { hp: 95, atk: 75, def: 80, spa: 100, spd: 110, spe: 30 },
		abilities: { 0: "Regenerator" },
		otherFormes: ["Slowking-Galar", "Slowking-Frostking"],
		formeOrder: ["Slowking", "Slowking-Galar", "Slowking-Frostking"],
	},
	slowkingfrostking: {
		num: 199,
		name: "Slowking-Frostking",
		baseSpecies: "Slowking",
		forme: "Frostking",
		types: ["Ice", "Poison"],
		baseStats: { hp: 95, atk: 40, def: 100, spa: 110, spd: 115, spe: 30 },
		abilities: { 0: "Regenerator" },
		heightm: 2,
		weightkg: 79.5,
		color: "Pink",
		eggGroups: ["Monster", "Water 1"],
		requiredMove: "Chilly Reception",
		battleOnly: "Slowking",
	},
	stakataka: {
		inherit: true,
		types: ["Rock", "Steel"],
		baseStats: { hp: 61, atk: 131, def: 211, spa: 53, spd: 101, spe: 13 },
		abilities: { 0: "Stack Shift" },
		otherFormes: ["Stakataka-Missile"],
		formeOrder: ["Stakataka", "Stakataka-Missile"],
	},
	stakatakamissile: {
		num: 805,
		name: "Stakataka-Missile",
		baseSpecies: "Stakataka",
		forme: "Missile",
		types: ["Rock", "Steel"],
		baseStats: { hp: 61, atk: 161, def: 13, spa: 53, spd: 71, spe: 211 },
		abilities: { 0: "Interdimensional Missile" },
		heightm: 5.5,
		weightkg: 820,
		color: "Gray",
		tags: ["Ultra Beast"],
		eggGroups: ["Undiscovered"],
		requiredAbility: "Stack Shift",
		battleOnly: "Stakataka",
	},
	sudowoodo: {
		inherit: true,
		types: ["Grass", "Fighting"],
		baseStats: { hp: 100, atk: 100, def: 115, spa: 30, spd: 100, spe: 30 },
		abilities: { 0: "Rock Head" },
		otherFormes: ["Sudowoodo-Nopseudo"],
		formeOrder: ["Sudowoodo", "Sudowoodo-Nopseudo"],
	},
	sudowoodonopseudo: {
		num: 185,
		name: "Sudowoodo-Nopseudo",
		baseSpecies: "Sudowoodo",
		forme: "Nopseudo",
		types: ["Grass"],
		baseStats: { hp: 250, atk: 165, def: 30, spa: 55, spd: 30, spe: 10 },
		abilities: { 0: "True Eden" },
		heightm: 16.2,
		weightkg: 538,
		color: "Brown",
		eggGroups: ["Mineral"],
		battleOnly: "Sudowoodo",
	},
	sunflora: {
		inherit: true,
		types: ["Grass"],
		baseStats: { hp: 75, atk: 75, def: 55, spa: 105, spd: 85, spe: 30 },
		abilities: { 0: "Chlorophyll" },
		otherFormes: ["Sunflora-Wilted"],
		formeOrder: ["Sunflora", "Sunflora-Wilted"],
	},
	sunflorawilted: {
		num: 192,
		name: "Sunflora-Wilted",
		baseSpecies: "Sunflora",
		forme: "Wilted",
		types: ["Grass", "Poison"],
		baseStats: { hp: 105, atk: 75, def: 105, spa: 135, spd: 105, spe: 100 },
		abilities: { 0: "Wither" },
		heightm: 0.8,
		weightkg: 8.5,
		color: "Yellow",
		eggGroups: ["Grass"],
		battleOnly: "Sunflora",
	},
	sylveon: {
		inherit: true,
		types: ["Fairy"],
		baseStats: { hp: 95, atk: 65, def: 65, spa: 110, spd: 130, spe: 60 },
		abilities: { 0: "Pixilate" },
		otherFormes: ["Sylveon-Lumineon"],
		formeOrder: ["Sylveon", "Sylveon-Lumineon"],
	},
	sylveonlumineon: {
		num: 700,
		name: "Sylveon-Lumineon",
		baseSpecies: "Sylveon",
		forme: "Lumineon",
		types: ["Fairy", "Psychic"],
		baseStats: { hp: 95, atk: 65, def: 85, spa: 130, spd: 130, spe: 95 },
		abilities: { 0: "Fairy Aura" },
		heightm: 1,
		weightkg: 23.5,
		color: "Pink",
		eggGroups: ["Field"],
		requiredMove: "Ribbon Shift",
		battleOnly: "Sylveon",
	},
	talonflame: {
		inherit: true,
		types: ["Fire", "Flying"],
		baseStats: { hp: 79, atk: 111, def: 76, spa: 74, spd: 74, spe: 136 },
		abilities: { 0: "Gale Wings" },
		otherFormes: ["Talonflame-Tempest"],
		formeOrder: ["Talonflame", "Talonflame-Tempest"],
	},
	talonflametempest: {
		num: 663,
		name: "Talonflame-Tempest",
		baseSpecies: "Talonflame",
		forme: "Tempest",
		types: ["Fire", "Flying"],
		baseStats: { hp: 79, atk: 130, def: 76, spa: 105, spd: 74, spe: 143 },
		abilities: { 0: "Tough Wings" },
		heightm: 1.2,
		weightkg: 24.5,
		color: "Red",
		eggGroups: ["Flying"],
		battleOnly: "Talonflame",
	},
	torterra: {
		inherit: true,
		types: ["Grass", "Ground"],
		baseStats: { hp: 110, atk: 114, def: 130, spa: 75, spd: 60, spe: 36 },
		abilities: { 0: "Shell Armor" },
		otherFormes: ["Torterra-Old"],
		formeOrder: ["Torterra", "Torterra-Old"],
	},
	torterraold: {
		num: 389,
		name: "Torterra-Old!",
		baseSpecies: "Torterra",
		forme: "Old",
		types: ["Grass", "Steel"],
		baseStats: { hp: 110, atk: 114, def: 55, spa: 75, spd: 55, spe: 116 },
		abilities: { 0: "Head-On" },
		heightm: 2.2,
		weightkg: 310,
		color: "Green",
		eggGroups: ["Monster", "Grass"],
		battleOnly: "Torterra",
	},
	trubbish: {
		inherit: true,
		types: ["Poison"],
		baseStats: { hp: 100, atk: 95, def: 85, spa: 60, spd: 82, spe: 100 },
		abilities: { 0: "Stench" },
		otherFormes: ["Trubbish-Mega-Dragon"],
		formeOrder: ["Trubbish", "Trubbish-Mega-Dragon"],
	},
	trubbishmegadragon: {
		num: 568,
		name: "Trubbish-Mega-Dragon",
		baseSpecies: "Trubbish",
		forme: "Mega-Dragon",
		types: ["Poison", "Flying"],
		baseStats: { hp: 80, atk: 55, def: 102, spa: 80, spd: 130, spe: 90 },
		abilities: { 0: "Pure Power" },
		heightm: 0.6,
		weightkg: 31,
		color: "Green",
		eggGroups: ["Mineral"],
		requiredAbility: "Stench",
		battleOnly: "Trubbish",
	},
	victini: {
		inherit: true,
		types: ["Fire", "Psychic"],
		baseStats: { hp: 100, atk: 100, def: 100, spa: 100, spd: 100, spe: 100 },
		abilities: { 0: "Victory Star" },
		otherFormes: ["Victini-Victorious"],
		formeOrder: ["Victini", "Victini-Victorious"],
	},
	victinivictorious: {
		num: 494,
		name: "Victini-Victorious",
		baseSpecies: "Victini",
		forme: "Victorious",
		types: ["Fire", "Psychic"],
		baseStats: { hp: 100, atk: 120, def: 70, spa: 120, spd: 70, spe: 120 },
		abilities: { 0: "Victory Finale" },
		heightm: 0.4,
		weightkg: 33.3,
		color: "Yellow",
		tags: ["Mythical"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Victini",
	},
	volcanion: {
		inherit: true,
		types: ["Fire", "Water"],
		baseStats: { hp: 80, atk: 110, def: 120, spa: 130, spd: 90, spe: 70 },
		abilities: { 0: "Water Absorb" },
		otherFormes: ["Volcanion-Surge"],
		formeOrder: ["Volcanion", "Volcanion-Surge"],
	},
	volcanionsurge: {
		num: 721,
		name: "Volcanion-Surge",
		baseSpecies: "Volcanion",
		forme: "Surge",
		types: ["Fire", "Steel"],
		baseStats: { hp: 80, atk: 85, def: 105, spa: 145, spd: 85, spe: 100 },
		abilities: { 0: "Supercritical" },
		heightm: 1.7,
		weightkg: 195,
		color: "Brown",
		tags: ["Mythical"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Volcanion",
	},
	volcarona: {
		inherit: true,
		types: ["Fire", "Bug"],
		baseStats: { hp: 85, atk: 60, def: 65, spa: 135, spd: 105, spe: 100 },
		abilities: { 0: "Flame Body" },
		otherFormes: ["Volcarona-Solstice", "Volcarona-Radiant"],
		formeOrder: ["Volcarona", "Volcanion-Solstice", "Volcarona-Radaint"],
	},
	volcaronasolstice: {
		num: 637,
		name: "Volcarona-Solstice",
		baseSpecies: "Volcarona",
		forme: "Solstice",
		types: ["Fairy", "Fire"],
		baseStats: { hp: 85, atk: 60, def: 85, spa: 105, spd: 135, spe: 80 },
		abilities: { 0: "Flame Body" },
		heightm: 1.6,
		weightkg: 46,
		color: "White",
		eggGroups: ["Bug"],
		requiredMove: "Morning Sun",
		battleOnly: "Volcarona",
	},
	volcaronaradiant: {
		num: 637,
		name: "Volcarona-Radiant",
		baseSpecies: "Volcarona",
		forme: "Radiant",
		types: ["Fire", "Psychic"],
		baseStats: { hp: 85, atk: 70, def: 75, spa: 150, spd: 105, spe: 115 },
		abilities: { 0: "Mega Sol" },
		heightm: 1.6,
		weightkg: 46,
		color: "White",
		eggGroups: ["Bug"],
		requiredMove: "Fiery Dance",
		battleOnly: "Volcarona",
	},
	weavile: {
		inherit: true,
		types: ["Dark", "Ice"],
		baseStats: { hp: 70, atk: 100, def: 85, spa: 45, spd: 85, spe: 125 },
		abilities: { 0: "Growing Bitterness" },
		otherFormes: ["Weavile-Frost"],
		formeOrder: ["Weavile", "Weavile-Frost"],
	},
	weavilefrost: {
		num: 461,
		name: "Weavile-Frost",
		baseSpecies: "Weavile",
		forme: "Frost",
		types: ["Dark", "Ice"],
		baseStats: { hp: 70, atk: 120, def: 105, spa: 65, spd: 105, spe: 145 },
		abilities: { 0: "Bitterness" },
		heightm: 1.1,
		weightkg: 34,
		color: "Black",
		eggGroups: ["Field"],
		requiredAbility: "Growing Bitterness",
		battleOnly: "Weavile",
	},
	wyrdeer: {
		inherit: true,
		types: ["Ice", "Psychic"],
		baseStats: { hp: 103, atk: 80, def: 72, spa: 115, spd: 90, spe: 65 },
		abilities: { 0: "Snow Warning" },
		otherFormes: ["Wyrdeer-Snowblind"],
		formeOrder: ["Wyrdeer", "Wyrdeer-Snowblind"],
	},
	wyrdeersnowblind: {
		num: 899,
		name: "Wyrdeer-Snowblind",
		baseSpecies: "Wyrdeer",
		forme: "Snowblind",
		types: ["Ice", "Psychic"],
		baseStats: { hp: 103, atk: 80, def: 72, spa: 130, spd: 90, spe: 100 },
		abilities: { 0: "Heart of Cold" },
		heightm: 1.8,
		weightkg: 105.1,
		color: "Gray",
		eggGroups: ["Field"],
		battleOnly: "Wyrdeer",
	},
	zarude: {
		inherit: true,
		types: ["Dark", "Grass"],
		baseStats: { hp: 105, atk: 120, def: 105, spa: 70, spd: 95, spe: 105 },
		abilities: { 0: "Natural Cure" },
		otherFormes: ["Zarude-Dada", "Zarude-Alchemist"],
		formeOrder: ["Zarude", "Zarude-Dada", "Zarude-Alchemist"],
	},
	zarudedada: {
		inherit: true,
		types: ["Dark", "Grass"],
		baseStats: { hp: 105, atk: 120, def: 105, spa: 70, spd: 95, spe: 105 },
		abilities: { 0: "Natural Cure" },
	},
	zarudealchemist: {
		num: 893,
		name: "Zarude-Alchemist",
		baseSpecies: "Zarude",
		forme: "Alchemist",
		types: ["Dark", "Grass"],
		baseStats: { hp: 105, atk: 70, def: 110, spa: 115, spd: 110, spe: 115 },
		abilities: { 0: "Herbal Elixir" },
		heightm: 1.8,
		weightkg: 70,
		color: "Black",
		eggGroups: ["Undiscovered"],
		battleOnly: ["Zarude", "Zarude-Dada"],
	},
	zeraora: {
		inherit: true,
		types: ["Electric", "Fighting"],
		baseStats: { hp: 88, atk: 112, def: 75, spa: 102, spd: 80, spe: 143 },
		abilities: { 0: "Electromorphosis" },
		otherFormes: ["Zeraora-Big"],
		formeOrder: ["Zeraora", "Zeraora-Big"],
	},
	zeraorabig: {
		num: 807,
		name: "Zeraora-Big",
		baseSpecies: "Zeraora",
		forme: "Big",
		types: ["Electric", "Fighting"],
		baseStats: { hp: 88, atk: 122, def: 90, spa: 102, spd: 110, spe: 143 },
		abilities: { 0: "Electric Surge" },
		heightm: 1.5,
		weightkg: 44.5,
		color: "Yellow",
		tags: ["Mythical"],
		eggGroups: ["Undiscovered"],
		battleOnly: "Zeraora",
	},
	// Advent mons now
	strobite: {
		num: 2000,
		name: "Strobite",
		types: ["Electric"],
		baseStats: { hp: 100, atk: 130, def: 110, spa: 50, spd: 70, spe: 65 },
		abilities: { 0: "Lightning Rod", 1: "Strong Jaw", H: "Intimidate" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	xurkitree: {
		inherit: true,
		otherFormes: ["Xurkitree-Sinnoh"],
		formeOrder: ["Xurkitree", "Zeraora-Sinnoh"],
	},
	xurkitreesinnoh: {
		num: 796,
		name: "Xurkitree-Sinnoh",
		baseSpecies: "Xurkitree",
		forme: "Sinnoh",
		types: ["Electric", "Fairy"],
		baseStats: { hp: 83, atk: 67, def: 89, spa: 127, spd: 103, spe: 71 },
		abilities: { 0: "Lighting Rod", 1: "Tangling Hair", H: "Sap Sipper" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	sandta: {
		num: 2002,
		name: "Sandta",
		types: ["Ground", "Water"],
		baseStats: { hp: 110, atk: 75, def: 85, spa: 95, spd: 85, spe: 75 },
		abilities: { 0: "Water Compaction", 1: "Water Veil", H: "Water Absorb" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	eiscue: {
		inherit: true,
		otherFormes: ["Eiscue-Noice", "Eiscue-Snowcone", "Eiscue-Snowcone-Nosnow"],
		formeOrder: ["Eiscue", "Eiscue-Noice", "Eiscue-Snowcone", "Eiscue-Snowcone-Nosnow"],
	},
	eiscuesnowcone: {
		num: 875,
		name: "Eiscue-Snowcone",
		baseSpecies: "Eiscue",
		forme: "Snowcone",
		types: ["Water", "Ice"],
		baseStats: { hp: 75, atk: 105, def: 95, spa: 65, spd: 115, spe: 50 },
		abilities: { 0: "Snow Face" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	eiscuesnowconenosnow: {
		num: 875,
		name: "Eiscue-Snowcone-Nosnow",
		baseSpecies: "Eiscue",
		forme: "Snowcone-Nosnow",
		types: ["Water", "Psychic"],
		baseStats: { hp: 75, atk: 105, def: 75, spa: 65, spd: 55, spe: 130 },
		abilities: { 0: "Ice Face" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		requiredAbility: "Snow Face",
		battleOnly: "Eiscue-Snowcone",
	},
	cardemelli: {
		num: 2004,
		name: "Cardemelli",
		types: ["Fairy", "Ground"],
		baseStats: { hp: 95, atk: 61, def: 120, spa: 89, spd: 76, spe: 54 },
		abilities: { 0: "Aroma Veil", H: "Magic Bounce" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	gingertar: {
		num: 2005,
		name: "Gingertar",
		types: ["Fire", "Dark"],
		baseStats: { hp: 100, atk: 134, def: 100, spa: 95, spd: 110, spe: 61 },
		abilities: { 0: "Ginger Stream", H: "Sturdy" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		otherFormes: ["Gingertar-Mega"],
		formeOrder: ["Gingertar", "Gingertar-Mega"],
	},
	gingertarmega: {
		num: 2005,
		name: "Gingertar-Mega",
		baseSpecies: "Gingertar",
		forme: "Mega",
		types: ["Fire", "Dark"],
		baseStats: { hp: 100, atk: 164, def: 120, spa: 95, spd: 150, spe: 71 },
		abilities: { 0: "Ginger Stream" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		requiredItem: "Gingerite",
	},
	nuzcracker: {
		num: 2007,
		name: "Nuzcracker",
		types: ["Grass", "Fighting"],
		baseStats: { hp: 90, atk: 105, def: 75, spa: 70, spd: 60, spe: 80 },
		abilities: { 0: "Chlorophyll", 1: "Dancer", H: "Little Soldier" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	smorgasbag: {
		num: 2008,
		name: "Smorgasbag",
		types: ["Poison"],
		baseStats: { hp: 138, atk: 65, def: 65, spa: 85, spd: 90, spe: 50 },
		abilities: { 0: "Gluttony", H: "Toxic Debris" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	sableye: {
		inherit: true,
		otherFormes: ["Sableye-Mega", "Sableye-Festive", "Sableye-Festive-Mega"],
		formeOrder: ["Sableye", "Sableye-Mega", "Sableye-Festive", "Sableye-Festive-Mega"],
	},
	sableyefestive: {
		num: 302,
		name: "Sableye-Festive",
		baseSpecies: "Sableye",
		forme: "Festive",
		types: ["Dark", "Grass"],
		baseStats: { hp: 70, atk: 75, def: 75, spa: 65, spd: 65, spe: 70 },
		abilities: { 0: "Pickpocket", 1: "Slush Rush", H: "Prankster" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	sableyefestivemega: {
		num: 302,
		name: "Sableye-Festive-Mega",
		baseSpecies: "Sableye",
		forme: "Festive-Mega",
		types: ["Dark", "Steel"],
		baseStats: { hp: 70, atk: 85, def: 125, spa: 85, spd: 115, spe: 40 },
		abilities: { 0: "Filter" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		requiredItem: "Sablenite",
	},
	mariahcarey: {
		num: 2010,
		name: "Mariah Carey",
		types: ["Normal", "Ice"],
		baseStats: { hp: 78, atk: 98, def: 70, spa: 114, spd: 70, spe: 95 },
		abilities: { 0: "Merciless", H: "Chilling Voice" },
		weightkg: 50, // i don't feel like googling it.
		eggGroups: ["Human-Like"], // yeah.
	},
	draydol: {
		num: 2011,
		name: "Draydol",
		types: ["Ground", "Rock"],
		baseStats: { hp: 60, atk: 105, def: 75, spa: 70, spd: 70, spe: 120 },
		abilities: { 0: "Serene Grace" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	gamesi: {
		num: 2012,
		name: "Gamesi",
		types: ["Dark", "Electric"],
		baseStats: { hp: 100, atk: 109, def: 70, spa: 109, spd: 70, spe: 60 },
		abilities: { 0: "Download", H: "Static" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	vipux: {
		num: 2013,
		name: "Vipux",
		types: ["Dragon", "Grass"],
		baseStats: { hp: 80, atk: 138, def: 84, spa: 122, spd: 100, spe: 100 },
		abilities: { 0: "Equal Share", 1: "Swindling", H: "Pickpocket" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	popsicelf: {
		num: 2014,
		name: "Popsicelf",
		types: ["Ice", "Fire"],
		baseStats: { hp: 68, atk: 111, def: 60, spa: 70, spd: 65, spe: 121 },
		abilities: { 0: "Flame Body", 1: "Clear Body", H: "Sweet Freezing" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	bellbeque: {
		num: 2015,
		name: "Bellbeque",
		types: ["Fire", "Steel"],
		baseStats: { hp: 75, atk: 60, def: 140, spa: 90, spd: 80, spe: 40 },
		abilities: { 0: "Mirror Armor", 1: "Anticipation", H: "Filter" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	chorislam: {
		num: 2016,
		name: "Chorislam",
		types: ["Normal", "Fighting"],
		baseStats: { hp: 80, atk: 105, def: 110, spa: 65, spd: 50, spe: 105 },
		abilities: { 0: "WellBaked Body" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	gholdengo: {
		inherit: true,
		otherFormes: ["Gholdengo-Festive"],
		formeOrder: ["Gholdengo", "Gholdengo-Festive"],
	},
	gholdengofestive: {
		num: 1000,
		name: "Gholdengo-Festive",
		baseSpecies: "Gholdengo",
		forme: "Festive",
		types: ["Grass", "Steel"],
		baseStats: { hp: 87, atk: 60, def: 96, spa: 123, spd: 101, spe: 84 },
		abilities: { 0: "Serene Grace" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	indeedee: {
		inherit: true,
		otherFormes: ["Indeedee-F", "Indeedee-Cook"],
		formeOrder: ["Indeedee", "Indeedee-F", "Indeedee-Cook"],
	},
	indeedeecook: {
		num: 876,
		name: "Indeedee-Cook",
		baseSpecies: "Indeedee",
		forme: "Cook",
		types: ["Psychic", "Fire"],
		baseStats: { hp: 70, atk: 55, def: 85, spa: 95, spd: 110, spe: 85 },
		abilities: { 0: "Aroma Veil", 1: "Gluttony", H: "Psychic Simmer" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	dulceirene: {
		num: 2019,
		name: "Dulceirene",
		types: ["Fairy"],
		baseStats: { hp: 76, atk: 70, def: 86, spa: 113, spd: 131, spe: 64 },
		abilities: { 0: "Fragilité Shield", H: "Aroma Veil" },
		otherFormes: ["Dulceirene-Mega"],
		formeOrder: ["Dulceirene", "Dulceirene-Mega"],
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	dulceirenemega: {
		num: 2019,
		name: "Dulceirene-Mega",
		baseSpecies: "Dulceirene",
		forme: "Mega",
		types: ["Fairy", "Ice"],
		baseStats: { hp: 76, atk: 70, def: 86, spa: 163, spd: 141, spe: 104 },
		abilities: { 0: "Filter" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		requiredItem: "Dulceirenite",
	},
	wreith: {
		num: 2021,
		name: "Wreith",
		types: ["Grass", "Ghost"],
		baseStats: { hp: 72, atk: 85, def: 130, spa: 85, spd: 86, spe: 44 },
		abilities: { 0: "Bristle" },
		otherFormes: ["Eternal Flower Wreith"],
		formeOrder: ["Wreith", "Eternal Flower Wreith"],
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	eternalflowerwreith: {
		num: 2021,
		name: "Eternal Flower Wreith",
		types: ["Fairy", "Poison"],
		baseStats: { hp: 72, atk: 104, def: 86, spa: 95, spd: 130, spe: 64 },
		abilities: { 0: "Ange Halo", H: "Flower Veil" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	clamperl: {
		inherit: true,
		otherFormes: ["Clamperl-Alola"],
		formeOrder: ["Clamperl", "Clamperl-Alola"],
	},
	clamperlalola: {
		num: 366,
		name: "Clamperl-Alola",
		baseSpecies: "Clamperl",
		forme: "Alola",
		types: ["Rock"],
		baseStats: { hp: 35, atk: 54, def: 45, spa: 74, spd: 55, spe: 82 },
		abilities: { 0: "Shell Armor", H: "Insomnia" },
		evos: ["Goodybyss", "Naughtail"],
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	goodybyss: {
		num: 2024,
		name: "Goodybyss",
		types: ["Rock", "Dragon"],
		baseStats: { hp: 55, atk: 84, def: 52, spa: 114, spd: 75, spe: 105 },
		abilities: { 0: "Swift Swim", H: "Good as Gold" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	naughtail: {
		num: 2025,
		name: "Naughtail",
		types: ["Rock", "Dark"],
		baseStats: { hp: 55, atk: 105, def: 52, spa: 114, spd: 75, spe: 84 },
		abilities: { 0: "Swift Swim", H: "Rock Head" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	gospiel: {
		num: 2026,
		name: "Gospiel",
		types: ["Psychic"],
		baseStats: { hp: 80, atk: 40, def: 95, spa: 75, spd: 100, spe: 30 },
		abilities: { 0: "Telepathy", H: "Levitate" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	rusalvia: {
		num: 2027,
		name: "Rusalvia",
		types: ["Psychic", "Water"],
		baseStats: { hp: 80, atk: 65, def: 100, spa: 130, spd: 105, spe: 50 },
		abilities: { 0: "Telepathy", H: "Liquid Voice" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	seraphexe: {
		num: 2028,
		name: "Seraphexe",
		types: ["Psychic", "Fire"],
		baseStats: { hp: 80, atk: 65, def: 105, spa: 100, spd: 130, spe: 50 },
		abilities: { 0: "Telepathy", H: "Trace" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	mirrelette: {
		num: 2029,
		name: "Mirrelette",
		types: ["Steel", "Ice"],
		baseStats: { hp: 70, atk: 60, def: 80, spa: 100, spd: 105, spe: 95 },
		abilities: { 0: "Shattered Reflection", 1: "Levitate", H: "Mirror Armor" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	klefki: {
		inherit: true,
		otherFormes: ["Klefki-McCallister"],
		formeOrder: ["Klefki", "Klefki-McCallister"],
	},
	klefkimccallister: {
		num: 707,
		name: "Klefki-McCallister",
		baseSpecies: "Klefki",
		forme: "McCallister",
		types: ["Steel", "Fire"],
		baseStats: { hp: 57, atk: 80, def: 91, spa: 80, spd: 87, spe: 75 },
		abilities: { 0: "Prankstwr", 1: "Flame Body", H: "Entrapment" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	sacchamorte: {
		num: 2001,
		name: "Sacchamorte",
		types: ["Dark", "Poison"],
		baseStats: { hp: 77, atk: 112, def: 81, spa: 80, spd: 70, spe: 105 },
		abilities: { 0: "Dancer", 1: "Sweet Veil", H: "Regenerator" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	treench: {
		num: 2002,
		name: "Treench",
		types: ["Dark", "Grass"],
		baseStats: { hp: 75, atk: 106, def: 80, spa: 50, spd: 80, spe: 114 },
		abilities: { 0: "Gift Stealer", H: "Mimicry" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	grincheartcaged: {
		num: 2003,
		name: "Grincheart-Caged",
		types: ["Fairy", "Steel"],
		baseStats: { hp: 100, atk: 65, def: 105, spa: 65, spd: 80, spe: 50 },
		abilities: { 0: "Heart Cage" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		otherFormes: ["Grincheart-Grown"],
		formeOrder: ["Grincheart-Caged", "Grincheart-Grown"],
	},
	grincheartgrown: {
		num: 2003,
		name: "Grincheart-Grown",
		baseSpecies: "Grincheart-Caged",
		forme: "Grown",
		types: ["Fairy", "Fighting"],
		baseStats: { hp: 100, atk: 150, def: 95, spa: 115, spd: 70, spe: 100 },
		abilities: { 0: "Heart Cage" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	lelitoccia: {
		num: 2005,
		name: "Lelitoccia",
		types: ["Ghost", "Rock"],
		baseStats: { hp: 61, atk: 43, def: 89, spa: 113, spd: 167, spe: 97 },
		abilities: { 0: "Beast Boost" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	deckherd: {
		num: 2006,
		name: "Deckherd",
		types: ["Normal", "Dark"],
		baseStats: { hp: 79, atk: 109, def: 109, spa: 89, spd: 99, spe: 49 },
		abilities: { 0: "Fluffy", 1: "Technician", H: "Cash Infusion" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	caneine: {
		num: 2007,
		name: "Caneine",
		types: ["Rock", "Fairy"],
		baseStats: { hp: 111, atk: 112, def: 93, spa: 74, spd: 65, spe: 86 },
		abilities: { 0: "Guard Dog", 1: "Stamina", H: "Tough Claws" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	picktreebel: {
		num: 2008,
		name: "Picktreebel",
		types: ["Grass", "Rock"],
		baseStats: { hp: 80, atk: 105, def: 65, spa: 100, spd: 70, spe: 80 },
		abilities: { 0: "Chlorophyll", 1: "Quick Draw", H: "Crystalize" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		otherFormes: ["Picktreebel-Mega"],
		formeOrder: ["Picktreebel-Mega", "Picktreebel-Mega"],
	},
	picktreebelmega: {
		num: 2008,
		name: "Picktreebel-Mega",
		baseSpecies: "Picktreebel",
		forme: "Mega",
		types: ["Grass", "Rock"],
		baseStats: { hp: 80, atk: 135, def: 85, spa: 125, spd: 95, spe: 80 },
		abilities: { 0: "Crystalize" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
		requiredItem: "Picktreelite",
	},
	twinklingshade: {
		num: 2011,
		name: "Twinkling Shade",
		types: ["Dark", "Flying"],
		baseStats: { hp: 104, atk: 70, def: 86, spa: 92, spd: 100, spe: 118 },
		abilities: { 0: "Protosynthesis" },
		tags: ["Paradox"],
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	irontwilight: {
		num: 2010,
		name: "Iron Twilight",
		types: ["Steel", "Dark"],
		baseStats: { hp: 96, atk: 76, def: 66, spa: 138, spd: 92, spe: 122 },
		abilities: { 0: "Quark Drive" },
		tags: ["Paradox"],
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	faerwork: {
		num: 2012,
		name: "Faerwork",
		types: ["Fire", "Fairy"],
		baseStats: { hp: 60, atk: 60, def: 80, spa: 105, spd: 80, spe: 105 },
		abilities: { 0: "Illuminate", 1: "Flash Fire", H: "Sheer Force" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	antaron: {
		num: 2013,
		name: "Antaron",
		types: ["Dragon", "Fire"],
		baseStats: { hp: 88, atk: 69, def: 85, spa: 143, spd: 97, spe: 79 },
		abilities: { 0: "Berserk", 1: "Dancer", H: "Good as Gold" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	snowglob: {
		num: 2014,
		name: "Snowglob",
		types: ["Ice", "Grass"],
		baseStats: { hp: 75, atk: 50, def: 60, spa: 90, spd: 120, spe: 90 },
		abilities: { 0: "Snow Warning" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	dinjingle: {
		num: 2015,
		name: "Dinjingle",
		types: ["Steel", "Fairy"],
		baseStats: { hp: 90, atk: 50, def: 100, spa: 110, spd: 90, spe: 70 },
		abilities: { 0: "Bell Choir" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	guywithsweater: {
		num: 2016,
		name: "Guywithsweater",
		types: ["Normal", "Fairy"],
		baseStats: { hp: 85, atk: 110, def: 110, spa: 50, spd: 70, spe: 65 },
		abilities: { 0: "Thick Fat", 1: "Rough Skin", H: "Stench" },
		weightkg: 50, // placeholder
		eggGroups: ["Human-Like"], // placeholder
	},
	gristletoe: {
		num: 2017,
		name: "Gristletoe",
		types: ["Poison", "Dark"],
		baseStats: { hp: 105, atk: 95, def: 90, spa: 50, spd: 110, spe: 70 },
		abilities: { 0: "Earth Eater", 1: "Poison Touch", H: "Corrosion" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	aegibashpolar: {
		num: 2018,
		name: "Aegibash-Polar",
		// baseSpecies: "Aegibash",
		// forme: "Polar",
		types: ["Steel", "Electric"],
		baseStats: { hp: 60, atk: 50, def: 110, spa: 140, spd: 80, spe: 60 },
		abilities: { 0: "Magnet Pull", 1: "Minus", H: "No Guard" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	gingermason: {
		num: 2019,
		name: "Gingermason",
		types: ["Fire", "Ground"],
		baseStats: { hp: 68, atk: 98, def: 87, spa: 66, spd: 93, spe: 98 },
		abilities: { 0: "WellBaked Body", 1: "Ice Body", H: "Simple" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	swadloon: {
		inherit: true,
		otherFormes: ["Swadloon-Festive"],
		formeOrder: ["Swadloon", "Swadloon-Festive"],
	},
	swadloonfestive: {
		num: 541,
		name: "Swadloon-Festive",
		baseSpecies: "Swadloon",
		forme: "Festive",
		types: ["Bug", "Grass"],
		baseStats: { hp: 55, atk: 63, def: 90, spa: 50, spd: 80, spe: 42 },
		abilities: { 0: "Social Retreat", 1: "Slush Rush", H: "Snow Cloak" },
		evos: ["Leavanny-Festive"],
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	leavanny: {
		inherit: true,
		otherFormes: ["Leavanny-Festive"],
		formeOrder: ["Leavanny", "Leavanny-Festive"],
	},
	leavannyfestive: {
		num: 542,
		name: "Leavanny-Festive",
		baseSpecies: "Leavanny",
		forme: "Festive",
		types: ["Bug", "Grass"],
		baseStats: { hp: 75, atk: 103, def: 70, spa: 75, spd: 70, spe: 108 },
		abilities: { 0: "Aroma Veil", 1: "Slush Rush", H: "Snow Cloak" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
	maushold: {
		inherit: true,
		otherFormes: ["Maushold-Four", "Maushold-Dysfunctional"],
		formeOrder: ["Maushold", "Maushold-Four", "Maushold-Dysfunctional"],
	},
	mausholddysfunctional: {
		num: 925,
		name: "Maushold-Dysfunctional",
		baseSpecies: "Maushold",
		forme: "Dysfunctional",
		types: ["Normal", "Rock"],
		baseStats: { hp: 74, atk: 95, def: 83, spa: 65, spd: 77, spe: 111 },
		abilities: { 0: "Technician", H: "Parental Bond" },
		weightkg: 50, // placeholder
		eggGroups: ["Undiscovered"], // placeholder
	},
};
